export function formatDateToAPI(date) {
  if (!date) return '';
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function addWorkingDays(start, count) {
  if (!start) return '';
  const date = new Date(start);
  let added = 0;

  while (added < count) {
    const dow = date.getDay();
    if (dow !== 0 && dow !== 6) added++;
    if (added === count) break;
    date.setDate(date.getDate() + 1);
  }

  return formatDateToAPI(date);
}

export function formatDate(date) {
  if (!date) return '';
  return new Date(date).toISOString().split('T')[0];
}

export const providerRoles = [
  'ES_SERVICE_PROVIDER_HEADS',
  'ES_SERVICE_PROVIDER_EMPLOYEES'
];
export const privilegeRoles = [
  'ES_GODS',
  'ES_ADMINS'
];
export const restrictedRoles = [
  'ES_GODS',
  'ES_ADMINS',
  'ES_REGION_MIO_EMPLOYEES'
];


export const getInitialMenuData = (initialData) => {
  const defaultMealsByDay = Array.from({ length: 10 }, () => ({
    breakfast: [],
    secondBreakfast: [],
    lunch: [],
    snack: [],
    dinner: [],
    lateDinner: [],
  }));

  if (!Array.isArray(initialData) || initialData.length === 0) {
    return {
      menuId: null,
      startDate: '',
      endDate: '',
      selectedAgeGroups: [],
      mealsByDay: defaultMealsByDay,
      mealTypes: { dinner: false, lateDinner: false },
    };
  }

  const menuHeader = initialData[0];

  // Парсинг содержимого меню по дням
  const mealsByDay = menuHeader.menuItems.map(dayMenuItem => ({
    breakfast: dayMenuItem.breakfast?.dish || [],
    secondBreakfast: dayMenuItem.secondBreakfast?.dish || [],
    lunch: dayMenuItem.lunch?.dish || [],
    snack: dayMenuItem.snack?.dish || [],
    dinner: dayMenuItem.dinner?.dish || [],
    lateDinner: dayMenuItem.lateDinner?.dish || [],
  }));

  // Определение активированных приемов пищи
  const hasDinner = mealsByDay.some(day => day.dinner.length > 0);
  const hasLateDinner = mealsByDay.some(day => day.lateDinner.length > 0);

  return {
    menuId: menuHeader.id || null,
    startDate: menuHeader.startDate || '',
    endDate: menuHeader.endDate || '',
    selectedAgeGroups: initialData.map(m => m.ageGroupId).filter(Boolean).map(String),
    mealsByDay: mealsByDay,
    mealTypes: { dinner: hasDinner, lateDinner: hasLateDinner },
  };
};